import { Injectable } from '@angular/core';

import { SessionStorageStateType } from '../model/session-storage-state';

const SESSION_STORAGE_KEY = 'estimate-state';

@Injectable({ providedIn: 'root' })
export class StatePersistenceService {
  persistState(key: string, value: SessionStorageStateType): void {
    const sessionStorageValue = sessionStorage.getItem(SESSION_STORAGE_KEY);

    if (sessionStorageValue) {
      const state = JSON.parse(sessionStorageValue);

      state[key] = value;

      sessionStorage.removeItem(SESSION_STORAGE_KEY);
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state));
    } else {
      const newState = { [key]: value };
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newState));
    }
  }

  getPersistedState(
    key: string,
    fallbackValue: SessionStorageStateType,
  ): SessionStorageStateType {
    const state = this.getPersistedStateBy(key);

    if (state) return state;

    return fallbackValue;
  }

  getPersistedStateBy(key: string): SessionStorageStateType {
    const sessionStorageValue = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (sessionStorageValue) {
      const state = JSON.parse(sessionStorageValue);
      return state[key] !== undefined ? state[key] : null;
    }
    return null;
  }
}
